/**
 * Error tracking SDK init frontend tenant (GlitchTip self-hosted).
 *
 * No-op se `VITE_ERROR_TRACKING_DSN` non valorizzato a build time.
 */

import * as errorTracking from '@sentry/react';

export function initErrorTracking(): void {
  const dsn = (import.meta.env.VITE_ERROR_TRACKING_DSN ?? '').trim();
  if (!dsn) return;

  const release = (import.meta.env.VITE_COMMIT_SHA ?? '').trim() || undefined;
  const environment = import.meta.env.MODE ?? 'production';

  errorTracking.init({
    dsn,
    release,
    environment,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    initialScope: {
      tags: { app: 'frontend-tenant' },
    },
  });
}

export { errorTracking };
